import axiosAuth from './axiosAuth'

export const getRasaUrl = (controller: AbortController) =>
    axiosAuth.get<string>('/rasa_url', {
        signal: controller.signal,
    })

export const putRasaUrl = (newUrl: string) => axiosAuth.put('/rasa_url', newUrl)
